export {
  COOKIE_NAME,
  ONE_YEAR_MS,
  INACTIVITY_LIMIT_MS,
  UNAUTHED_ERR_MSG,
  AXIOS_TIMEOUT_MS,
} from "@shared/const";

/** Path to the in-app login page (email + password form). */
export const getLoginUrl = (): string => "/login";

/**
 * Direct browser → Google Drive upload. When true (the default), the client
 * PUTs upload chunks straight to Drive's resumable session URL and resolves the
 * fileId via /api/drive-upload/finalize — no upload bytes pass through our
 * server. When false, it uses the legacy /api/drive-upload/chunk server proxy.
 *
 * Rollback lever: set VITE_DIRECT_DRIVE_UPLOAD=false and rebuild/redeploy to
 * fall back to the proxy path without a code change.
 */
export const USE_DIRECT_DRIVE_UPLOAD: boolean =
  ((import.meta as any)?.env?.VITE_DIRECT_DRIVE_UPLOAD ?? "true") !== "false";
